var React = require('react');

function CheckCircleFilled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.5 29.3333C23.8638 29.3333 29.8333 23.3638 29.8333 16C29.8333 8.63619 23.8638 2.66666 16.5 2.66666C9.13619 2.66666 3.16666 8.63619 3.16666 16C3.16666 23.3638 9.13619 29.3333 16.5 29.3333Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M10.5 16L14.5 20L22.5 12","stroke":"white","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircleFilled.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = CheckCircleFilled;

CheckCircleFilled.default = CheckCircleFilled;
